import api from "../Api";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    null;

  return token ? { Authorization: `Bearer ${token}` } : {};
};

// ✅ Get AI Drinks
export const getAiDrinks = async () => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.get("/admin/get/ai/drinks", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data;
    /*
      expected:
      {
        data: [
          {
            id,
            drink_name,
            ingredients, // لاحظ غالباً جاية string JSON
            temperature,
            is_approved,
            ...
          }
        ]
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Update AI Drink (with image upload)
export const updateAiDrink = async (drinkId, payload) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
    // ملاحظة: لا تضع Content-Type هنا، axios سيضبطه تلقائيًا مع FormData
  };

  const formData = new FormData();

  // نصوص
  if (payload?.drink_name !== undefined) formData.append("drink_name", payload.drink_name);
  if (payload?.drink_name_en !== undefined) formData.append("drink_name_en", payload.drink_name_en);
  if (payload?.name !== undefined) formData.append("name", payload.name);
  if (payload?.name_en !== undefined) formData.append("name_en", payload.name_en);
  if (payload?.description !== undefined) formData.append("description", payload.description);
  if (payload?.description_en !== undefined) formData.append("description_en", payload.description_en);

  // أرقام / قيم
  if (payload?.status !== undefined) formData.append("status", payload.status);
  if (payload?.temperature !== undefined) formData.append("temperature", payload.temperature);
  if (payload?.category_id !== undefined) formData.append("category_id", payload.category_id);
  if (payload?.tasts !== undefined) formData.append("tasts", payload.tasts); // حسب اسم الحقل في الباك
  if (payload?.price !== undefined) formData.append("price", payload.price);
  if (payload?.prepare_time !== undefined) formData.append("prepare_time", payload.prepare_time);


  // صورة (File)
  if (payload?.image) formData.append("image", payload.image);

  try {
    const res = await api.post(`/admin/update/ai/drink/${drinkId}`, formData, {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data;
    /*
      expected:
      {
        success: true,
        message: "تم تحديث المشروب بنجاح",
        data: {...}
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};

